import React from "react";

export default function RerollButton({ onClick, disabled, label, count }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="group flex items-center gap-1.5 px-3 py-1.5 rounded-full
                 bg-zinc-900/60 border border-zinc-800 text-md font-semibold
                 text-zinc-300 transition
                 hover:text-zinc-100 hover:border-zinc-700
                 disabled:opacity-40 disabled:cursor-not-allowed"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-3.5 h-3.5 transition-transform duration-500 group-hover:rotate-[360deg]"
      >
        <polyline points="23 4 23 10 17 10" />
        <polyline points="1 20 1 14 7 14" />
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
      </svg>
      <span>{label}</span>
      {typeof count === "number" && (
        <span className="text-zinc-500 group-hover:text-zinc-400 tabular-nums">
          · {count}
        </span>
      )}
    </button>
  );
}
